(() => {
  const recommendationSelector = '.product-recommendations, .rj-cart-recommendations';
  const deferredImageSelector = 'img[data-rj-deferred-image]';
  let imageObserver = null;

  function moveRecommendationsAfterFooter() {
    const footer = document.querySelector('body > footer') || document.querySelector('footer');
    if (!footer) return;

    const recommendation = document.querySelector(recommendationSelector);
    if (!recommendation) return;

    const section = recommendation.closest('.shopify-section') || recommendation;

    if (section.dataset.rjAfterFooter === 'true' && section.previousElementSibling === footer) {
      return;
    }

    footer.insertAdjacentElement('afterend', section);
    section.dataset.rjAfterFooter = 'true';
  }

  function hydrateDeferredImage(image) {
    if (!image || image.dataset.rjDeferredHydrated === 'true') return;

    const srcset = image.dataset.srcset;
    const src = image.dataset.src;

    if (srcset) image.srcset = srcset;
    if (src) image.src = src;

    image.dataset.rjDeferredHydrated = 'true';
    image.removeAttribute('data-srcset');
    image.removeAttribute('data-src');

    if (imageObserver) imageObserver.unobserve(image);
  }

  function observeDeferredImages() {
    const images = document.querySelectorAll(deferredImageSelector);
    if (!images.length) return;

    if (!('IntersectionObserver' in window)) {
      images.forEach(hydrateDeferredImage);
      return;
    }

    if (!imageObserver) {
      imageObserver = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) hydrateDeferredImage(entry.target);
          });
        },
        {
          root: null,
          rootMargin: '500px 0px',
          threshold: 0.01,
        }
      );
    }

    images.forEach((image) => {
      if (image.dataset.rjDeferredObserved === 'true') return;
      image.dataset.rjDeferredObserved = 'true';
      imageObserver.observe(image);
    });
  }

  function init() {
    moveRecommendationsAfterFooter();
    observeDeferredImages();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', init);
  document.addEventListener('shopify:section:reorder', init);
})();
